if (!window.DigitalizModules) window.DigitalizModules = {};

if (!window.DigitalizModules.ArticlesGrid) {
  class ArticlesGrid {
    constructor(root) {
      this.root = root;
      this.splide = null;
      this.handlerRef = null;

      this.mobileSliderEnabled = root.dataset.mobileSlider === 'true';
      if (!this.mobileSliderEnabled) return;

      this.sliderEl = root.querySelector('[data-articles-slider]');
      if (!this.sliderEl) return;

      this.mql = window.matchMedia('(max-width: 990px)');
      this.handlerRef = () => this._sync();
      this._sync();

      if (this.mql.addEventListener) {
        this.mql.addEventListener('change', this.handlerRef);
      } else {
        this.mql.addListener(this.handlerRef);
      }
    }

    _sync() {
      if (this.mql.matches) {
        if (!this.splide) this._mount();
      } else {
        if (this.splide) this._destroy();
      }
    }

    _mount() {
      if (typeof window.Splide !== 'function') return;

      const sliderEl = this.sliderEl;
      const showDots     = sliderEl.dataset.pagination === 'true';
      const loopMode     = sliderEl.dataset.loopMode || 'none';
      const autoplay     = sliderEl.dataset.autoplay === 'true';
      const interval     = parseInt(sliderEl.dataset.autoplayInterval, 10) || 4000;
      const pauseOnHover = sliderEl.dataset.pauseOnHover === 'true';
      const speed        = parseInt(sliderEl.dataset.speed, 10) || 600;
      const colsMobile   = parseInt(sliderEl.dataset.colsMobile, 10) || 2;

      const options = {
        perPage: colsMobile,
        gap: '0.7rem',
        pagination: showDots,
        // Prev/next arrows (markup in the section) — the slider is mobile-only.
        arrows: true,
        speed: speed,
      };

      if (loopMode === 'loop') {
        options.type = 'loop';
      } else if (loopMode === 'rewind') {
        options.rewind = true;
      }

      if (autoplay) {
        options.autoplay = true;
        options.interval = interval;
        options.pauseOnHover = pauseOnHover;
      }

      this.splide = new window.Splide(sliderEl, options).mount();
      this.root.classList.add('is-slider-active');
    }

    _destroy() {
      if (this.splide) {
        try { this.splide.destroy(true); } catch (e) { /* already destroyed */ }
        this.splide = null;
      }
      this.root.classList.remove('is-slider-active');

      if (this.sliderEl) {
        // Splide's destroy(true) doesn't strip `is-initialized` from the root.
        // Left in place, its vendor rule
        //   `.splide.is-initialized:not(.is-active) .splide__list { display: block }`
        // beats our grid by specificity and stacks cards into a single column.
        this.sliderEl.classList.remove('is-initialized', 'is-rendered', 'is-active');

        // Splide may also leave inline styles (widths, transforms) on slides.
        this.sliderEl.querySelectorAll('.splide__slide').forEach(slide => {
          slide.removeAttribute('style');
        });
      }
    }

    destroy() {
      if (this.mql && this.handlerRef) {
        if (this.mql.removeEventListener) {
          this.mql.removeEventListener('change', this.handlerRef);
        } else {
          this.mql.removeListener(this.handlerRef);
        }
      }
      this._destroy();
    }
  }

  window.DigitalizModules.ArticlesGrid = ArticlesGrid;

  function initAll(root) {
    root.querySelectorAll('[data-articles-grid]').forEach(el => new ArticlesGrid(el));
  }

  initAll(document);

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
    if (event.target.matches('[data-articles-grid]')) new ArticlesGrid(event.target);
  });
}
